import * as React from "react";

import ModalComponent from "./ModalComponent";

import '../../styles/Popup.css'
import '../../styles/Button.css'
import '../../styles/Modal.css'

export default class ModalMessage extends ModalComponent
{
    constructor(props)
    {
        super(props);
        this.state = {
            message: "Error",
            confirmCallback: null,
            isError: false
        }
    }

    setMessage = (sMessage, bErr) =>
    {
        this.setState({
            message: sMessage,
            isError: bErr ? true : false
        })
    }

    setConfirmCallback = (callback) =>
    {
        this.setState({
            confirmCallback: callback
        })
    }

    confirmAction = () =>
    {
        if (this.state.confirmCallback && "function" === typeof this.state.confirmCallback)
        {
            this.state.confirmCallback.call();
        }
        this.toggleModal();
    }

    render = () =>
    {
        return (
            this.state.openModal ?
                <div className="PopupBackground">
                    <div className="PopupContent">

                        <p className={!this.state.isError ? "Modal__message" : "Modal__message Modal__messageErr"}>{this.state.message}</p>

                        <button className="wrcButton wrcButton--confirm" onClick={this.confirmAction}>
                            OK
                        </button>
                    </div>
                </div>
                : null
        )
    }
}